import React, { useState } from 'react';
import './OnboardingWizard.css';

const STEPS = [
  {
    id: 'experiencia',
    titulo: 'Há quanto tempo você opera na Bolsa?',
    subtitulo: 'Vamos personalizar sua experiência com o FatCat.',
    tipo: 'single',
    opcoes: [
      { valor: 'menos_6m',  label: 'Menos de 6 meses',  icon: '🌱' },
      { valor: '6m_1a',     label: '6 meses a 1 ano',   icon: '📈' },
      { valor: '1_3a',      label: '1 a 3 anos',        icon: '📊' },
      { valor: '3_5a',      label: '3 a 5 anos',        icon: '🎯' },
      { valor: 'mais_5a',   label: 'Mais de 5 anos',    icon: '🏆' },
    ],
  },
  {
    id: 'conhecimento',
    titulo: 'Qual seu nível em análise quantitativa?',
    subtitulo: 'Assim podemos ajustar os tutoriais e explicações.',
    tipo: 'single',
    opcoes: [
      { valor: 'iniciante',     label: 'Iniciante — ainda estou aprendendo',    icon: '🔰' },
      { valor: 'intermediario', label: 'Intermediário — já opero com método',   icon: '⚡' },
      { valor: 'avancado',      label: 'Avançado — entendo indicadores quant.',  icon: '🔬' },
      { valor: 'profissional',  label: 'Profissional — trabalho com mercado',   icon: '🎓' },
    ],
  },
  {
    id: 'como_conheceu',
    titulo: 'Como você conheceu o FatCat?',
    subtitulo: 'Ajuda a entendermos onde estamos chegando melhor.',
    tipo: 'single',
    opcoes: [
      { valor: 'instagram',  label: 'Instagram',            icon: '📸' },
      { valor: 'youtube',    label: 'YouTube',               icon: '▶️' },
      { valor: 'indicacao',  label: 'Indicação de amigo',   icon: '👥' },
      { valor: 'google',     label: 'Google / pesquisa',    icon: '🔍' },
      { valor: 'telegram',   label: 'Telegram / grupo',     icon: '💬' },
      { valor: 'outro',      label: 'Outro',                 icon: '✨' },
    ],
  },
  {
    id: 'expectativas',
    titulo: 'O que você mais espera do FatCat?',
    subtitulo: 'Selecione tudo que se aplica.',
    tipo: 'multi',
    opcoes: [
      { valor: 'sinais_entrada',    label: 'Sinais claros de entrada e saída'     },
      { valor: 'backtest',          label: 'Backtest validado com dados reais'    },
      { valor: 'economizar_tempo',  label: 'Economizar tempo de análise'          },
      { valor: 'win_rate',          label: 'Melhorar meu win rate'                },
      { valor: 'quant',             label: 'Entender análise quantitativa'        },
      { valor: 'consistencia',      label: 'Consistência e disciplina operacional'},
    ],
  },
];

export default function OnboardingWizard({ email, onComplete }) {
  const [stepIndex, setStepIndex] = useState(0);
  const [respostas, setRespostas]   = useState({});
  const [saving, setSaving]         = useState(false);
  const [error, setError]           = useState('');

  const step = STEPS[stepIndex];
  const total = STEPS.length;
  const progresso = ((stepIndex) / total) * 100;

  const valor = respostas[step.id];
  const podeProsseguir = step.tipo === 'single'
    ? !!valor
    : Array.isArray(valor) && valor.length > 0;

  const toggleMulti = (v) => {
    setRespostas(prev => {
      const arr = Array.isArray(prev[step.id]) ? prev[step.id] : [];
      return {
        ...prev,
        [step.id]: arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v],
      };
    });
  };

  const handleNext = async () => {
    if (!podeProsseguir) return;
    if (stepIndex < total - 1) {
      setStepIndex(i => i + 1);
      return;
    }
    setSaving(true);
    setError('');
    try {
      const resp = await fetch('/api/clientes/onboarding', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ perfil: respostas }),
      });
      if (!resp.ok) throw new Error('Erro ao salvar.');
      onComplete();
    } catch (err) {
      setError('Não foi possível salvar. Tente novamente.');
      setSaving(false);
    }
  };

  return (
    <div className="ob-overlay">
      <div className="ob-card">

        {/* Header */}
        <div className="ob-header">
          <div className="ob-brand">Fat<span>Cat</span></div>
          <div className="ob-step-label">Passo {stepIndex + 1} de {total}</div>
        </div>

        {/* Progress bar */}
        <div className="ob-progress-track">
          <div className="ob-progress-fill" style={{ width: `${progresso}%` }} />
        </div>

        {/* Content */}
        <div className="ob-body">
          <h2 className="ob-titulo">{step.titulo}</h2>
          <p className="ob-sub">{step.subtitulo}</p>

          <div className={`ob-opcoes ob-opcoes--${step.tipo}`}>
            {step.opcoes.map(op => {
              const sel = step.tipo === 'single'
                ? valor === op.valor
                : Array.isArray(valor) && valor.includes(op.valor);
              return (
                <button
                  key={op.valor}
                  className={`ob-op${sel ? ' ob-op--sel' : ''}`}
                  onClick={() => {
                    if (step.tipo === 'single') {
                      setRespostas(prev => ({ ...prev, [step.id]: op.valor }));
                    } else {
                      toggleMulti(op.valor);
                    }
                  }}
                >
                  {op.icon && <span className="ob-op-icon">{op.icon}</span>}
                  <span className="ob-op-label">{op.label}</span>
                  {sel && (
                    <span className="ob-op-check">
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          {error && <div className="ob-error">{error}</div>}
        </div>

        {/* Footer */}
        <div className="ob-footer">
          {stepIndex > 0 && (
            <button className="ob-btn-back" onClick={() => setStepIndex(i => i - 1)}>
              ← Voltar
            </button>
          )}
          <button
            className="ob-btn-next"
            onClick={handleNext}
            disabled={!podeProsseguir || saving}
          >
            {saving
              ? <span className="ob-spinner" />
              : stepIndex < total - 1 ? 'Continuar →' : 'Entrar na plataforma →'
            }
          </button>
        </div>
      </div>
    </div>
  );
}
